// api/checkout.api.js - UPDATED
import API_BASE, {getAuthHeaders} from "./api";

export class CheckoutService {
    // Validate checkout
    static async validateCheckout(checkoutData) {
        const response = await fetch(`${API_BASE}/checkout/validate`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(checkoutData),
            credentials: 'include' // For cookies if using them
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to validate checkout');
        }

        return data;
    }

    // Apply offer at checkout
    static async applyOffer(code) {
        const response = await fetch(`${API_BASE}/checkout/apply-offer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            },
            body: JSON.stringify({ code })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to apply offer');
        }

        return data;
    }

    // Remove offer
    static async removeOffer(code) {
        const response = await fetch(`${API_BASE}/checkout/remove-offer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            },
            body: JSON.stringify({ code })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to remove offer');
        }

        return data;
    }

    // Confirm checkout and create order
    static async confirmCheckout(orderData) {
        const response = await fetch(`${API_BASE}/checkout/confirm`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(orderData),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to create order');
        }

        return data;
    }

    // Create order (wrapper for confirmCheckout)
    static async createOrder(orderData) {
        return this.confirmCheckout(orderData);
    }

    // Get shipping methods
    static async getShippingMethods() {
        const response = await fetch(`${API_BASE}/checkout/shipping-methods`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            }
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get shipping methods');
        }

        return data.data || data;
    }

    // Get payment methods
    static async getPaymentMethods() {
        const response = await fetch(`${API_BASE}/payments/methods`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to get payment methods');
        }

        return data.data || data;
    }

    // Calculate totals
    static async calculateTotals(checkoutData) {
        const response = await fetch(`${API_BASE}/checkout/calculate`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(checkoutData),
            credentials: 'include'
        });

        const data = await response.json();
        // console.log(data.data)
        if (!response.ok) {
            throw new Error(data.message || 'Failed to calculate totals');
        }

        return data.data || data;
    }

    // Create payment intent
    static async createPaymentIntent(orderId, provider, paymentMethod = 'card') {
        const response = await fetch(`${API_BASE}/payments/create-razorpay-order`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({ orderId, provider, paymentMethod }),
            credentials: 'include'
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to create payment intent');
        }

        return data;
    }

    // Confirm payment
    static async confirmPayment(paymentId, paymentIntentId, provider) {
        const response = await fetch(`${API_BASE}/payments/confirm`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
            },
            body: JSON.stringify({ paymentId, paymentIntentId, provider })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || 'Failed to confirm payment');
        }

        return data;
    }
}